import { createSlice } from "@reduxjs/toolkit";

const initialState = {
    leaveConfigDetailsData: {},
    applyLeaveHistoryData: {},
    selectedCardLeaveData: {},
    UploadfileObjectId: [],
    SelectedUploadFiles: [],
};

const leaveConfigSlice = createSlice({
    name: "leaveConfigSlice",
    initialState,
    reducers: {
        saveLeaveDetailsData: (state, action) => {
            return { ...state, leaveConfigDetailsData: action.payload }
        },
        saveLeaveDetailsHistoryData: (state, action) => {
            return { ...state, applyLeaveHistoryData: action.payload }
        },
        saveSelectedCardLeaveData: (state, action) => {
            return { ...state, selectedCardLeaveData: action.payload }
        },
        saveUploadfileObjectId: (state, action) => {
            return { ...state, UploadfileObjectId: [...state?.UploadfileObjectId, action.payload] }
        },
        saveSelectedUploadFiles: (state, action) => {
            const data = { name: action.payload.file.name, randomId: action.payload.randomId }
            return { ...state, SelectedUploadFiles: [...state.SelectedUploadFiles, data] }
        },
        deleteSelectedFiles: (state, action) => {
            const clone = JSON.parse(JSON.stringify(state.SelectedUploadFiles))
            const cloneObjectId = JSON.parse(JSON.stringify(state.UploadfileObjectId))
            const index = clone.findIndex(doc => doc.randomId === action.payload)
            const index1 = cloneObjectId.findIndex(doc => doc.randomId === action.payload)
            if (index !== -1) {
                clone.splice(index, 1)
            }
            if (index1 !== -1) {
                cloneObjectId.splice(index, 1)
            }
            return { ...state, SelectedUploadFiles: clone, UploadfileObjectId: cloneObjectId }
        }
    },
});

export const { saveLeaveDetailsData, deleteSelectedFiles, saveSelectedUploadFiles, saveLeaveDetailsHistoryData, saveSelectedCardLeaveData, saveUploadfileObjectId } = leaveConfigSlice.actions;
export default leaveConfigSlice.reducer;
